import getEnv from "@/common/util/env"

enum PRODUCT_FLAVOUR_ENUM {
  AUTOMOTIVE = "AUTOMOTIVE",
  NON_AUTOMOTIVE = "NON_AUTOMOTIVE"
}
enum PRODUCT_TYPE_ENUM {
  ESSENTIAL = "ESSENTIAL",
  PREMIUM = "PREMIUM",
  ENTERPRISE = "ENTERPRISE"
}

export enum DGK_FEATURES_ENUM {
  ASSETS = "assets",
  POLICIES = "policies",
  PUBLICATION_TEMPLATES = "publication_templates",
  CONNECTORS_MANAGEMENT = "connectors_management",
  OFFER = "offer",
  CONTRACTS_MANAGEMENT = "contracts_management", // this is for allowing negotiation of contracts [negotion-button/cancel-contract-button]
  AGREEMENTS_MANAGEMENT = "agreements_management", // this is for display of agreements [consumer/provider]
  DOWNLOAD_HISTORY = "download_history"
}
// DGK features
export const DGK = [
  DGK_FEATURES_ENUM.ASSETS,
  DGK_FEATURES_ENUM.POLICIES,
  DGK_FEATURES_ENUM.PUBLICATION_TEMPLATES,
  DGK_FEATURES_ENUM.CONNECTORS_MANAGEMENT,
  DGK_FEATURES_ENUM.OFFER,
  DGK_FEATURES_ENUM.CONTRACTS_MANAGEMENT,
  DGK_FEATURES_ENUM.AGREEMENTS_MANAGEMENT,
  DGK_FEATURES_ENUM.DOWNLOAD_HISTORY
]

export enum DIGITAL_TWIN_FEATURES_ENUM {
  CSV_FILE_UPLOAD = "csv_file_upload",
  BROWSE = "browse",
  USE_CASES = "use_cases"
}
export const DT = [
  DIGITAL_TWIN_FEATURES_ENUM.CSV_FILE_UPLOAD,
  DIGITAL_TWIN_FEATURES_ENUM.BROWSE,
  DIGITAL_TWIN_FEATURES_ENUM.USE_CASES
]

export enum CX_CORE_FEATURES_ENUM {
  CERTIFICATE_MANAGEMENT = "certificate_management",
  CONVERTERS = "converters",
  CROSS_MAPPINGS = "cross_mappings",
  EDIT_MODELS = "edit_models",
  JOBS = "jobs",
  MESSAGING = "messaging",
  PCF_EXCHANGE = "pcf_exchange"
}
const CX_CORE = [
  // CX_CORE_FEATURES_ENUM.CERTIFICATE_MANAGEMENT,
  CX_CORE_FEATURES_ENUM.CONVERTERS,
  CX_CORE_FEATURES_ENUM.CROSS_MAPPINGS,
  CX_CORE_FEATURES_ENUM.EDIT_MODELS,
  CX_CORE_FEATURES_ENUM.JOBS,
  CX_CORE_FEATURES_ENUM.MESSAGING,
  CX_CORE_FEATURES_ENUM.PCF_EXCHANGE
]

export enum OTHER_PREMIUM_FEATURES {
  SWAGGER = "swagger"
}
const OTHER_PREMIUM = [OTHER_PREMIUM_FEATURES.SWAGGER]

const FeatureMapping: {
  [key: string]: {
    [key: string]: string[][]
  }
} = {
  [PRODUCT_TYPE_ENUM.ESSENTIAL]: {
    [PRODUCT_FLAVOUR_ENUM.NON_AUTOMOTIVE]: [DGK],
    [PRODUCT_FLAVOUR_ENUM.AUTOMOTIVE]: [DGK]
  },
  [PRODUCT_TYPE_ENUM.PREMIUM]: {
    [PRODUCT_FLAVOUR_ENUM.AUTOMOTIVE]: [DGK, DT, CX_CORE, OTHER_PREMIUM]
  },
  [PRODUCT_TYPE_ENUM.ENTERPRISE]: {
    [PRODUCT_FLAVOUR_ENUM.AUTOMOTIVE]: [DGK, DT, CX_CORE, OTHER_PREMIUM]
  }
}

type Features =
  | CX_CORE_FEATURES_ENUM
  | DIGITAL_TWIN_FEATURES_ENUM
  | DGK_FEATURES_ENUM
  | OTHER_PREMIUM_FEATURES

export function featureCheck(feature: Features) {
  const currentProductFlavour = getEnv("VITE_PRODUCT_FLAVOUR") as string // Accessing the environment variable
  const currentProductType = getEnv("VITE_PRODUCT_TYPE") as string // Accessing the environment variable
  const featureList: Features[] = FeatureMapping[currentProductType][
    currentProductFlavour
  ].flat() as unknown as Features[]

  // Check if all the features are included in the selected feature list
  return featureList.includes(feature)
}
